import '../../public/css/media/_homepage.scss';
import React from 'react';
import Helmet from 'react-helmet';
import AdvisoryModal from './AdvisoryModal'
import { v4 as uuid } from 'uuid';
import { netcoreScript } from '../utils/utils';

const createReactClass = require('create-react-class');
const Home = createReactClass({
  getInitialState: function () {
    return {
      homeContent: "<div></div>",
      showModal: false,
    }
  },
  componentDidMount() {
    window.scrollTo(0, 0);

    // <!-- Lightning Bolt Begins -->
    const lbscript = document.createElement("script");
    lbscript.type = "text/javascript";
    lbscript.src = "/js/lightningbolt.js";
    lbscript.async = true;
    document.body.appendChild(lbscript);

    const lbscript1 = document.createElement("script");
    lbscript1.type = "text/javascript";
    lbscript1.setAttribute('id', 'lightning_bolt');
    lbscript1.src = "//cdn-akamai.mookie1.com/LB/LightningBolt.js";
    lbscript1.async = true;
    document.body.appendChild(lbscript1);
    // <!-- Lightning Bolt Ends -->

    // <!-- NetCore Script -->
    const accountNumber = this.props.login.fetched && this.props.login.login && this.props.login.login.party && this.props.login.login.party.account_number ? this.props.login.login.party.account_number : '' ;
    window.smartech && netcoreScript(accountNumber);
    // <!-- NetCore Script -->    
  },
  componentWillMount() {
    this.props.getCmsBody('homepage');
    this.props.getModalBlocks('home');
    this.timeOut = setTimeout(() => this.setState({showModal: true}), 7000)
  },
  componentWillReceiveProps(nextProps) {

    const homeContent = nextProps.cms.getCms && nextProps.cms.CmsContent ? nextProps.cms.CmsContent.data.content.body : this.state.homeContent;
    const homeModalContent = nextProps.cms.getModal && nextProps.cms.modalContent && nextProps.cms.modalContent.data.variable === "Homepage-Modal" ? nextProps.cms.modalContent.data.status : false;
    this.setState({ homeContent , homeModalContent });
  },
  componentDidUpdate(prevProps) {
    var x = document.getElementsByClassName("lbcx");

    if (this.props.cms.getCms) {
      let signup = document.getElementById('home-sign-up');
      let signin = document.getElementById('home-sign-in');

      if (this.props.auth.isAuthenticated) {
        signup.style.display = 'none';
        signin.style.display = 'none';
      } else {
        signup.style.display = 'block';
        signin.style.display = 'block';
      }
    }

    for (var i = 0; i < x.length; i++) {
      document.body.removeChild(x.item(i));
    }

    const script = document.createElement("script");
    script.setAttribute('class', 'lbcx');
    script.type = "text/javascript";
    script.src = "/js/dropdown.js";
    script.async = true;
    document.body.appendChild(script);

    const script3 = document.createElement("script");
    script3.setAttribute('class', 'lbcx');
    script3.type = "text/javascript";
    script3.src = "/js/custom.js";
    script3.async = true;
    document.body.appendChild(script3);

    for (var j = 0; j < x.length; j++) {
      document.body.removeChild(x.item(j));
    }
  },

  homeModal() {
    return { __html: this.props.cms.getModal ? this.props.cms.modalContent.data.content.body : null, };
  },

  componentWillUnmount() {
    clearTimeout(this.timeOut);
  },

  render() {
    const axel = Math.random() + "";
    const a = axel * 10000000000000;
    return (
      <div>
        {/* 
          Start of Floodlight Tag: Please do not remove
          Activity name of this tag: Home Page
          URL of the webpage where the tag is expected to be placed: https://www.shippingcart.com/
          This tag must be placed between the <body> and </body> tags, as close as possible to the opening tag.
          Creation Date: 02/04/2020
        */}
        <iframe title={uuid()} src={`https://9848754.fls.doubleclick.net/activityi;src=9848754;type=homeo0;cat=homep0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=${a}?`} width="1" height="1" frameBorder="0" style={{ display: 'none' }}></iframe>
        <noscript>
          <iframe title={uuid()} src="https://9848754.fls.doubleclick.net/activityi;src=9848754;type=homeo0;cat=homep0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=1?" width="1" height="1" frameBorder="0" style={{ display: 'none' }}></iframe>
        </noscript>
        {/*  End of Floodlight Tag: Please do not remove   */}
        <Helmet
          title="ShippingCart | Ship Your Finds"
          meta={[
            { name: 'description', content: "ShippingCart lets you shop from online stores in the US & the UK & ship straight to the PH. Sign up today & enjoy low rates with fast delivery." },
          ]}
        />
        <div className="body-wrapper">
          <div className="main-wrapper" dangerouslySetInnerHTML={({ __html: this.state.homeContent })} />

          {this.state.showModal && this.state.homeModalContent ?
            <AdvisoryModal show={this.props.cms.showAdvisoryModal['home']}
              close={dispatch => this.props.closeModal('home')}
              content={this.homeModal()}
            />
            : null
          }
        </div>
      </div>
    )
  },
});

export default Home;



/** WEBPACK FOOTER **
 ** ./src/components/Home.js
 **/